import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="newhome-footer">
      <div className="newhome-footer-bottom">
        <small>Copyright © {new Date().getFullYear()} FAFA. All rights reserved.</small>
        <div style={{ marginTop: '0.5rem', textAlign: 'center', fontSize: 'smaller' }}>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
